<template>
  <v-col>
    <v-row
      class="d-flex align-stretch">
      <v-col
        v-bind="colAttrs"
        class="invoice-parameter-column">
        <Autocomplete
          label="Tipo de Nível *"
          hide-details
          :value="form.entityLevel"
          :items="[
            {type: 'CARRIER', label: 'Operadora'},
            {type: 'FINANCIAL_GROUP', label: 'Grupo Financeiro'},
            {type: 'CONTRACT', label: 'Contrato'},
            {type: 'SUB_CONTRACT', label: 'Subcontrato'},
          ]"
          :rules="[rule.required]"
          :disabled="loadingEntities || !inLevelSelectionStep"
          item-text="label"
          item-value="type"
          v-bind="autocompleteAttrs"
          @change="setEntityLevel"
        />
      </v-col>
      <v-col
        v-bind="colAttrs"
        v-if="carrierEntityLevel"
        class="invoice-parameter-column">
        <Autocomplete
          label="Operadora"
          @change="setFormInsuranceCarrier"
          :value="form.carrierId"
          :items="carriers"
          :rules="[rule.required]"
          :disabled="!inLevelSelectionStep"
          item-text="xipp_commercial_name"
          item-value="id"
          hide-details
          v-bind="autocompleteAttrs"
        />
      </v-col>
      <v-col
        v-bind="colAttrs"
        v-if="financialGroupEntityLevel"
        class="invoice-parameter-column">
        <Autocomplete
          label="Grupo Financeiro"
          @change="setFormFinancialGroup"
          :value="form.financialGroupId"
          :items="financialGroups"
          :rules="[rule.required]"
          :disabled="!inLevelSelectionStep"
          item-text="name"
          item-value="id"
          hide-details
          v-bind="autocompleteAttrs"
        />
      </v-col>
      <v-col
        v-bind="colAttrs"
        v-if="contractEntityLevel"
        class="invoice-parameter-column">
        <Autocomplete
          label="Contrato"
          @change="setFormContract"
          :value="form.contractId"
          :items="stepContracts"
          :rules="[rule.required]"
          :disabled="!inLevelSelectionStep"
          :loading="loadStepContracts"
          item-text="text"
          item-value="id"
          hide-details
          v-bind="autocompleteAttrs"
        />
      </v-col>
      <v-col
        v-bind="colAttrs"
        v-if="subContractEntityLevel"
        class="invoice-parameter-column">
        <Autocomplete
          label="Subcontrato"
          @change="setFormSubContract"
          :value="form.subContractId"
          :items="stepSubContracts"
          :rules="[rule.required]"
          :disabled="!inLevelSelectionStep"
          :loading="loadStepSubcontracts"
          item-text="text"
          item-value="id"
          hide-details
          v-bind="autocompleteAttrs"
        />
      </v-col>
    </v-row>
  </v-col>
</template>
<script>
import InvoiceParametersMixin from '@/shared/mixins/invoiceParameters/InvoiceParametersMixin';
import Autocomplete from '@/components/Default/Autocomplete.vue';
import ContractsMixin from '@/shared/mixins/sdi/contractsMixin';
import InvoiceParameterText from './InvoiceParameterText.vue';
import Formatters from '@/shared/formatters/formatters';
import Functions from '@/shared/functions/functions';
import { mapGetters, mapMutations } from 'vuex';
export default {
  name: "SelectionStepFlow",
  data: () => ({
    formatter: new Formatters(),
    function: new Functions(),
    stepSubContracts: [],
    stepContracts: [],
    loadStepContracts: false,
    loadStepSubcontracts: false,
  }),
  components: {
    TextBase: InvoiceParameterText,
    Autocomplete,
  },
  mixins: [
    InvoiceParametersMixin,
    ContractsMixin,
  ],
  methods: {
    ...mapMutations({
      cleanEntities: 'invoice-parameter/cleanEntities',
      updateSetting: 'invoice-parameter/updateSetting',
    }),
      async setEntityLevel(entityType) {
      if (!entityType) {
        this.cleanEntities();
        return;
      }

      await this.updateEntityLevel(entityType);
    },
    setFormInsuranceCarrier(carrierId) {
      this.updateSetting({ carrierId: carrierId });

      if (this.form.financialGroupId) {
        this.setFormFinancialGroup(this.form.financialGroupId, true);
      }

      this.setFormContract(null);
      this.setFormSubContract(null);
    },
    async setFormFinancialGroup(financialGroupId, updating = false) {
      this.stepContracts = [];
      this.stepSubContracts = [];

      if (!updating) {
        this.updateSetting({ financialGroupId: financialGroupId });
        this.setFormContract(null);
        this.setFormSubContract(null);
      }

      if (!this.form.financialGroupId) return;

      await this.fetchContractsByFinancialGroupId();
    },
    async setFormContract(contractId, updating = false) {
      this.stepSubContracts = [];
      if (!updating) {
        this.updateSetting({ contractId: contractId });
        this.setFormSubContract(null);
      }

      if (!this.form.contractId) return;

      await this.fetchSubcontractsByContractId();
    },
    setFormSubContract(value) {
      this.updateSetting({ subContractId: value });
    },
    async fetchContractsByFinancialGroupId() {
      try {
        this.stepContracts = [];
        this.loadStepContracts = true;
        const contracts = await this.getContractsByFinancialGroupIdVerifyRhProtegido(
          this.form.financialGroupId,
          this.isRHProtegido
        );

        if (!Array.isArray(contracts) || contracts.length === 0) return;

        const contractsFormatted = this.function.formatContractDescription('byFinancialGroupId', contracts);

        this.stepContracts = contractsFormatted.filter((contract) => contract.carrier_id.id === this.form.carrierId);
      } catch (error) {
        console.error("Error fetching contracts:", error);
      } finally {
        this.loadStepContracts = false;
      }
    },
    async fetchSubcontractsByContractId() {
      try {
        this.loadStepSubcontracts = true;
        this.stepSubContracts = await this.getSubContractsByContractId(
          this.form.contractId
        );
      } catch (error) {
        console.error("Error fetching subcontracts:", error);
      } finally {
        this.loadStepSubcontracts = false;
      }
    },
  },
  computed: {
    ...mapGetters({
      isUpdatingConfig: 'invoice-parameter/isUpdatingConfig',
      financialGroups: 'invoice-parameter/financialGroups',
      loadingEntities: 'invoice-parameter/loadingEntities',
      step: 'invoice-parameter/invoiceParameterStep',
      isRHProtegido: 'user-info/isRHProtegido',
      carriers: 'invoice-parameter/carriers',
      form: 'invoice-parameter/form',
    }),
    carrierEntityLevel() {
      return ['CARRIER', 'FINANCIAL_GROUP', 'CONTRACT', 'SUB_CONTRACT'].some(level => level === this.form.entityLevel);
    },
    financialGroupEntityLevel() {
      return ['FINANCIAL_GROUP', 'CONTRACT', 'SUB_CONTRACT'].some(level => level === this.form.entityLevel);
    },
    contractEntityLevel() {
      return ['CONTRACT', 'SUB_CONTRACT'].some(level => level === this.form.entityLevel);
    },
    subContractEntityLevel() {
      return ['SUB_CONTRACT'].some(level => level === this.form.entityLevel);
    },
  },
  async mounted() {
    if (this.form.contractId) {
      await this.setFormFinancialGroup(this.form.financialGroupId, true);
    }
    if (this.form.subContractId) {
      await this.setFormContract(this.form.contractId, true);
    }
  },
}
</script>
<style lang="scss">
@import "@/shared/styles/invoiceParameters/default.scss";
</style>